import { setFilter } from './actions/filter'
import { setPage } from './actions/page'
import { fetchPosts } from './actions/posts'

export function pushStateChange(dispatch, getState){
	let appState = getState();

	let filter = appState.filter;
	let page = appState.page;
	let pushState = {filter, page};

	window.history.pushState(pushState, '', '');
}

export function replaceState(appState){
	let filter = appState.filter;
	let page = appState.page;
	let pushState = {filter, page};

	window.history.replaceState(pushState, '', '');
}

export function popState(state, dispatch){
	dispatch(setFilter(state.filter));
	dispatch(setPage(state.page.page));
	dispatch(fetchPosts());
}
